import { render, staticRenderFns } from "./financeiro-centro-de-custo.vue?vue&type=template&id=32c28de0&scoped=true"
import script from "./financeiro-centro-de-custo.vue?vue&type=script&lang=ts"
export * from "./financeiro-centro-de-custo.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-centro-de-custo.vue?vue&type=style&index=0&id=32c28de0&prod&lang=scss&scoped=true"
import style1 from "./financeiro-centro-de-custo.vue?vue&type=style&index=1&id=32c28de0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c28de0",
  null
  
)

export default component.exports